/**
 * Compact label for an undercard round on rails/chips. NFL preseason
 * undercards (generated titles "Preseason Week N") become "Pre N"; everything
 * else keeps the legacy "Wk {round}" — non-NFL events use round 0 as a plain
 * sort hint (e.g. March Madness "First Four"), so the round value alone can
 * never imply preseason.
 */
export function weekShortLabel(round: number | null | undefined, title?: string | null): string {
  if (round == null) return '\u2014';
  const m = title?.match(/preseason week (\d+)/i);
  if (m) return `Pre ${m[1]}`;
  return `Wk ${round}`;
}
